import { GET_COMPANY_STATUSES } from 'src/api/graphql/queries/companyStatuses.gql';
import { fetchList } from './fetchLists';

export const getCompanyStatuses = () =>
	fetchList({
		query: GET_COMPANY_STATUSES,
	});
